// pages/invoices/EditInvoicePage.tsx
import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { Container, Typography, Breadcrumbs, Link as MuiLink, Alert, CircularProgress, Box } from '@mui/material';
import { Link } from 'react-router-dom';
import InvoiceForm from '../../components/invoices/InvoiceForm';
import axiosInstance from '../../utils/axiosConfig';

const EditInvoicePage: React.FC = () => {
  const { id } = useParams<{ id: string }>();
  const navigate = useNavigate();
  const [loading, setLoading] = useState(true);
  const [error, setError] = useState<string | null>(null);
  const [invoice, setInvoice] = useState<any>(null);

  useEffect(() => {
    const fetchInvoice = async () => {
      if (!id) {
        setError('Invoice ID not provided');
        setLoading(false);
        return;
      }

      try {
        const response = await axiosInstance.get(`/api/invoices/${id}`);
        setInvoice(response.data);
        
        // Check if invoice can be edited
       // if (response.data.status !== 'draft') {
        //  setError('This invoice cannot be edited because it has already been submitted.');
       // }
      } catch (err: any) {
        console.error('Error fetching invoice:', err);
        setError(err.response?.data?.message || 'Failed to load invoice');
      } finally {
        setLoading(false);
      }
    };

    fetchInvoice();
  }, [id]);

  const handleSubmit = (invoice: any) => {
    navigate('/admin/invoices');
  };

  const handleCancel = () => {
    navigate('/admin/invoices');
  };

  if (loading) {
    return (
      <Container maxWidth="xl">
        <Box display="flex" justifyContent="center" alignItems="center" minHeight="400px">
          <CircularProgress />
          <Typography sx={{ ml: 2 }}>Loading invoice...</Typography>
        </Box>
      </Container>
    );
  }

  if (error) {
    return (
      <Container maxWidth="xl">
        <Breadcrumbs aria-label="breadcrumb" sx={{ my: 2 }}>
          <MuiLink component={Link} to="/" color="inherit">
            Home
          </MuiLink>
          <MuiLink component={Link} to="/admin/invoices" color="inherit">
            Invoices
          </MuiLink>
          <Typography color="text.primary">Edit Invoice</Typography>
        </Breadcrumbs>

        <Alert severity="error" sx={{ mt: 2 }}>
          {error}
        </Alert>
      </Container>
    );
  }

  return (
    <Container maxWidth="xl">
      <Breadcrumbs aria-label="breadcrumb" sx={{ my: 2 }}>
        <MuiLink component={Link} to="/" color="inherit">
          Home
        </MuiLink>
        <MuiLink component={Link} to="/admin/invoices" color="inherit">
          Invoices
        </MuiLink>
        <Typography color="text.primary">
          Edit Invoice {invoice?.invoiceNumber}
        </Typography>
      </Breadcrumbs>

      <InvoiceForm 
        invoiceId={id} 
        onSubmit={handleSubmit} 
        onCancel={handleCancel} 
      />
    </Container>
  );
};

export default EditInvoicePage;